import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseFullscreenModule } from '@fuse/components/fullscreen';
import { FuseNavigationModule } from '@fuse/components/navigation';
import { BarNotificationsModule } from 'app/layout/common/notifications/bar-notifications.module';
import { SharedModule } from 'app/shared/shared.module';
import { ModernLayoutComponent } from 'app/layout/layouts/horizontal/modern/modern.component';
import { FuseAlertModule } from '@fuse/components/alert';
import { UserMenuModule } from '../../../common/user-menu/user-menu.module';
import { HelpMenuModule } from '../../../common/help-menu/help-menu.module';
import { LanguageMenuModule } from '../../../common/language-menu/language-menu.module';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';

@NgModule({
  declarations: [ModernLayoutComponent],
  imports: [
    HttpClientModule,
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    FuseFullscreenModule,
    FuseNavigationModule,
    BarNotificationsModule,
    SharedModule,
    FuseAlertModule,
    UserMenuModule,
    HelpMenuModule,
    LanguageMenuModule,
    FuseLoadingBarModule,
  ],
  exports: [ModernLayoutComponent],
})
export class ModernLayoutModule {}
